const crewCodePattern = /^[A-Z0-9]{6}$/;
const crewInvitePattern = /^CREW INVITE \/\/ \/join\/([A-Z0-9]{6})$/i;

export function crewInviteMessage(code: string): string {
  const normalized = code.trim().toUpperCase();
  if (!crewCodePattern.test(normalized)) throw new Error('Invalid crew code');
  return `CREW INVITE // /join/${normalized}`;
}

export function crewInviteCode(body: string): string | null {
  return crewInvitePattern.exec(body.trim())?.[1]?.toUpperCase() ?? null;
}
